import { render, staticRenderFns } from "./PackageBlockForm.vue?vue&type=template&id=e397e760"
import script from "./PackageBlockForm.vue?vue&type=script&lang=js"
export * from "./PackageBlockForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports